export const CHECKOUT = "checkout"
export const SHIPPING = "shipping"
export const STANDARD = "standard"
export const NAVIGATION = "navigation"
export const ENTER_ADDRESS_MANUALLY = "enter address manually"
export const SAVE_AND_CONTINUE = "save & continue"
export const CONTINUE = "continue"
export const DELIVERY_OPTIONS = "delivery options"
export const MORE_DETAILS = "more details"
export const LANDING = "landing page"
export const CALL_SUPPORT_PHONE_NUMBER = "call support number"
export const HELP_SUPPORT = "help support"
export const CUSTOMER_SUPPORT = "customer support"
export const ORDER_SUMMARY = "order summary"
export const EDIT_CART = "edit cart"
export const LOAD_MORE = "load more"
export const PRODUCT_NAVIGATION = "product navigation"
export const PROMO = "promo"
export const PAYMENT_BILLING = "payment & billing"
export const CREDIT_CARD = "credit card"
export const REVIEW = "review"
export const CHECKOUT_WITH = "checkout with"
export const CHECKOUT_PROCESS_BUTTON = "process"
export const CHECKOUT_PCIPAL = "pci pal"
export const TERMS_OF_USE = "terms of use"
export const PRIVACY_POLICY = "privacy policy"
export const CHECKOUT_WITH_PAYPAL = "checkout with paypal"
export const PAYPAL = "paypal"
export const PAYMENTS = "payments"
export const CREATE_A_QUICK_ACCOUNT = "create a quick account"
export const FORGOT_PASSWORD = "forgot password"
export const PASSWORD_RESET = "password reset"
export const NEXT = "next"
export const HOMEOWNER_ACCOUNT = "homeowner account"
export const PROFESSIONAL_ACCOUNT = "professional account"
export const SAVE_CHANGES = "save changes"
export const SHIPPING_VERIFY_ADDRESS = "shipping verify address"
export const BILLING_INFORMATION = "billing information"
export const PLACE_ORDER = "place order"
export const PAYMENT_METHOD = "payment method"
export const EXPAND = "expand"
export const COLLAPSE = "collapse"
export const SIGN_IN = "sign in"
export const MOUSE_OVER = "mouseover"
export const SHOW_PASSWORD = "show password"
export const HIDE_PASSWORD = "hide password"
export const CITY_DROPDOWN = "city dropdown selection"
export const PROFESSIONAL = "professional"
export const SELECT_BUSINESS_TYPE = "select business type"
export const SAVE_ADDRESS_TO_MY_ACCOUNT = "save address to my account"
export const CHECKBOX = "checkbox"
export const SIGN_ME_UP_FOR_THE_E_NEWSLETTER = "sign me up for the e-newsletter"
export const SHIPPING_RESTRICTIONS = "shipping restrictions"
export const SUBMIT = "submit"
export const RESEND_EMAIL = "resend email"
export const PAYPAL_ERROR = "paypal error"
export const CART_LABEL = "cart"
export const NOT_APPLICABLE = "not applicable"
